import * as React from 'react';
import { FilespaceUsage, PlanTier } from 'fs-api-client';
import DimensionEnum = FilespaceUsage.DimensionEnum;
import { getCurrencySymbol } from '../../../webportal/utils/utilFunctions';

interface BillingTierDetailsProps {
    billingTiers: PlanTier[];
    currency: string;
    planDimension: DimensionEnum;
}

interface BillingTierDetailsState {

}

export class BillingTierDetails extends React.Component<BillingTierDetailsProps, BillingTierDetailsState> {

    constructor(props: BillingTierDetailsProps) {
        super(props);
        this.renderPlanTier = this.renderPlanTier.bind(this);
        this.renderPlanTierPrice = this.renderPlanTierPrice.bind(this);
    }

    render() {
        return (
            this.renderPlanTier(this.props.billingTiers)
        );
    }
    private static formatPlanPrice(planPrice: string, currency: string): string {
        const currencySymbol = getCurrencySymbol(currency);
        return `${currencySymbol}${planPrice}`;
    }

    private getUnitType(value: number | string): string {
        const plural = value === 'Inf' || value > 1;
        switch (this.props.planDimension) {
            case DimensionEnum.Capacity:
            case DimensionEnum.ManagedCapacity:
            case DimensionEnum.Storage:
            case DimensionEnum.Egress:
                return 'TB';
            case FilespaceUsage.DimensionEnum.FilespaceUsers:
                return plural ? 'users' : 'user';
            case FilespaceUsage.DimensionEnum.ConnectedDevices:
                return plural ? 'device' : 'devices';
            case FilespaceUsage.DimensionEnum.FilespaceDays:
                return plural ? 'day' : 'days';
            default:
                return '';
        }
    }

    private renderPlanTier(planTiers: PlanTier[]): JSX.Element[] {
        return planTiers.map((planTier: PlanTier, index: number) => {
            const upTo = planTier.upTo ? planTier.upTo : 'Inf';
            const from = planTier.from ? planTier.from : 0;
            return (
                <div className="tier" key={index}>
                    <p>
                        <span>From: </span>
                        {from} {this.getUnitType(from)}
                    </p>
                    <p>
                        <span>Up to: </span>
                        {upTo} {upTo && this.getUnitType(upTo)}
                    </p>
                    {this.renderPlanTierPrice(planTier)}
                </div>

            );
        });
    }

    private renderPlanTierPrice(planTier: PlanTier): JSX.Element | null {
        if (planTier.flatPrice && planTier.flatPrice !== '0' ) {
            return (
                <React.Fragment>
                    <p>
                        <span>Flat price: </span>
                        {BillingTierDetails.formatPlanPrice(planTier.flatPrice, this.props.currency)}
                    </p>
                </React.Fragment>
            );
        }
        if (planTier.pricePerUnit && planTier.pricePerUnit !== '0') {
            return (
                <React.Fragment>
                    <p>
                        <span>Price per unit: </span>
                        {BillingTierDetails.formatPlanPrice(planTier.pricePerUnit, this.props.currency)}
                    </p>
                </React.Fragment>
            );
        }
        if (planTier.pricePerUnit === '0' && planTier.pricePerUnit === '0') {
            return (
                <React.Fragment>
                    <p>
                        <span>Price per unit: </span>
                        {getCurrencySymbol(this.props.currency)}0
                    </p>
                </React.Fragment>
            );
        }
        return null;
    }

}



// WEBPACK FOOTER //
// ./src/backoffice/components/billing/BillingTierDetails.tsx